import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageTransition from "../WrapComponents/PageTransition";
import RevealOnScroll from "../WrapComponents/RevealOnScroll";
import axiosInstance from "../Axiosintances/Axiosinstance";

const ServiceDetails = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServiceview = async () => {
      try {
        const res = await axiosInstance.get(`service/api/v1/public_services/${id}/`);
        setService(res.data);
      } catch (error) {
        console.error("Error loading service:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServiceview();
  }, [id]);

  if (loading) {
    return (
      <PageTransition>
        <div className="py-32 text-center">
          <div className="animate-spin h-12 w-12 mx-auto border-b-2 border-black dark:border-white rounded-full"></div>
          <p className="mt-4 text-gray-500 dark:text-gray-300">Loading details...</p>
        </div>
      </PageTransition>
    );
  }

  if (!service) {
    return (
      <PageTransition>
        <div className="py-32 text-center text-gray-500 dark:text-gray-300">
          Service not found.
        </div>
      </PageTransition>
    );
  }

  return (
    <PageTransition>
      <div className="bg-gray-50 dark:bg-gray-950 min-h-screen pb-20">

        {/* Minimal Hero */}
        <div className="flex flex-col items-center pt-14 px-6">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-auto object-contain"
            />
          </div>

          <h1 className="mt-8 text-4xl md:text-5xl font-bold text-gray-900 dark:text-white text-center">
            {service.name}
          </h1>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-5 mt-12">
          <RevealOnScroll direction="up">
            <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300 whitespace-pre-line">
              {service.description}
            </p>
          </RevealOnScroll>

          {service.more_details && (
            <RevealOnScroll direction="up" className="mt-12">
              <h2 className="text-3xl font-semibold mb-4 text-gray-900 dark:text-white">
                Additional Information
              </h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                {service.more_details}
              </p>
            </RevealOnScroll>
          )}
        </div>

      </div>
    </PageTransition>
  );
};

export default ServiceDetails;